import { useTranslate } from "src/i18n";

export const useConsentModalTranslate = () => {
  const { t } = useTranslate();

  return {
    title: t("consent_modal.title", "Будем на связи, если это будет полезно"),
    description: t(
      "consent_modal.description",
      "Иногда мы можем делиться важной информацией о сервисе, новых возможностях или способах сделать его использование ещё удобнее. Свяжемся только по делу и без лишнего.",
    ),
    agreement: t("consent_modal.tabs.agreement", "Да, можно связаться"),
    disagreement: t("consent_modal.tabs.disagrement", "Нет, спасибо"),
  };
};
